import React, { useContext, useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import Typography from 'kingpin/atoms/Typography';
import Icon from 'kingpin/atoms/Icon';
import PopUpMenu from 'kingpin/atoms/PopUpMenu';
import FavouritesContext from 'contexts/FavouritesContext';
import TextInput from 'kingpin/atoms/TextInput';
import LeftNavItem from '../../../Common/LeftNavItem';
import NavMenuPopup from './NavMenuPopup';
import PopUpMenuChevron from './PopUpMenuChevron';

const FavouriteItem = ({ favourite }: { favourite: ContentView }) => {
  const link = useMemo(() => {
    if (favourite.type === 'report') {
      return `/content/${favourite.typeId}`;
    } else if (favourite.type === 'dashboard') {
      return `/content/${favourite.typeId}`;
    } else if (favourite.type === 'scorecard') {
      return `/content/${favourite.typeId}`;
    }

    return undefined;
  }, [favourite.type, favourite.typeId]);

  if (!link) {
    return null;
  }

  return (
    <NavLink to={link}>
      <NavMenuPopup.ItemDiv>
        <Icon icon={'start - filled'} />
        <Typography.Body type={'Label 14'} isEllipsis ellipsisPosition="right">
          {favourite.name}
        </Typography.Body>
      </NavMenuPopup.ItemDiv>
    </NavLink>
  );
};

const FavouritesMenuPopup = () => {
  const { favourites } = useContext(FavouritesContext);
  const [searchText, setSearchText] = useState<string>('');

  const shownFavourites = useMemo(() => {
    return favourites.filter((f) => {
      if (
        f.type !== 'report' &&
        f.type !== 'dashboard' &&
        f.type !== 'scorecard'
      ) {
        return false;
      }

      return f.name.toLowerCase().includes(searchText.toLowerCase());
    });
  }, [favourites, searchText]);

  return (
    <NavMenuPopup.PopupDiv>
      <div style={{ padding: '8px 8px 12px 8px' }}>
        <TextInput
          placeholder="Search Favorites..."
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          icon={'search'}
          autoFocus={true}
        />
      </div>
      {shownFavourites.map((item) => (
        <FavouriteItem key={item.typeId} favourite={item} />
      ))}
      <NavMenuPopup.Divider />
      <NavLink to={'/favourites'}>
        <NavMenuPopup.ItemViewAllDiv>
          <Typography.Body type={'Body 14'} color={'var(--color-status-info)'}>
            View All Favorites
          </Typography.Body>
          <Icon icon={'arrow-right'} color={'var(--color-status-info)'} />
        </NavMenuPopup.ItemViewAllDiv>
      </NavLink>
    </NavMenuPopup.PopupDiv>
  );
};

const FavouritesMenu = () => {
  const { favourites } = useContext(FavouritesContext);
  const { pathname } = useLocation();
  const isSelected = useMemo(() => {
    return pathname === '/favourites';
  }, [pathname]);

  if (favourites.length === 0) {
    return null;
  }

  return (
    <PopUpMenu
      trigger={({ isOpen }: { isOpen: boolean }) => (
        <LeftNavItem isOpen={isOpen || isSelected}>
          <Typography.Body type={'Label 14'}>Favorites</Typography.Body>
          <PopUpMenuChevron isOpen={isOpen} />
        </LeftNavItem>
      )}
      children={() => <FavouritesMenuPopup />}
      position={'bottom-start'}
    />
  );
};

export default FavouritesMenu;
